var map = {
	"./i1.png": "sHFq",
	"./i10.png": "7nUY",
	"./i10en.png": "xlEt",
	"./i1en.png": "YMv+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sRZE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet ^\.\/i1.*\.png$
// module id = sRZE
// module chunks = 0